import { useEffect, useRef, useState } from 'react';

/**
 * Adds `in-view` class when the element scrolls into view.
 * Optional delay (ms) for staggered reveals.
 */
export function useReveal(delay = 0) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => setVisible(true), delay);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);

  return { ref, className: visible ? 'reveal in-view' : 'reveal' };
}
